module.exports = __webpack_public_path__ + "img/google-play.b51b24f9.svg";